// extracted by mini-css-extract-plugin
module.exports = {"imageLoadingSkeleton":"ImageLoading_imageLoadingSkeleton__2cWxa","imageLoadingImg":"ImageLoading_imageLoadingImg__2NNtB"};